import { escapeAttr, escapeHtml } from "@emkit/builder-core";
export const MAP_DEFAULTS = {
    provider: "openstreetmap",
    query: "18.4821,-69.9312",
    zoom: 12,
    aspectRatio: "16/9",
    radius: 12,
    title: "Map",
};
function buildUrl(props) {
    if (props.provider === "google") {
        const q = encodeURIComponent(props.query);
        return `https://www.google.com/maps?q=${q}&z=${props.zoom ?? 12}&output=embed`;
    }
    // OSM expects a bbox — approximate one around the centre point.
    const parts = props.query.split(",").map((s) => Number.parseFloat(s.trim()));
    const lat = parts[0];
    const lng = parts[1];
    if (lat === undefined ||
        lng === undefined ||
        !Number.isFinite(lat) ||
        !Number.isFinite(lng)) {
        return "";
    }
    const zoom = props.zoom ?? 12;
    // Wider span at lower zoom, tighter at higher zoom.
    const span = 0.5 / Math.max(1, 2 ** Math.max(0, zoom - 8));
    const bbox = [lng - span, lat - span, lng + span, lat + span].join(",");
    return `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat},${lng}`;
}
export const mapWidget = {
    type: "map",
    defaultProps: MAP_DEFAULTS,
    renderHtml(props) {
        const url = buildUrl(props);
        if (!url) {
            return `<div class="emk-map emk-map--error" style="padding:16px;background:#fef2f2;color:#991b1b;border:1px solid #fecaca;border-radius:8px;font-size:13px">Invalid map coordinates — use "lat,lng" format (OSM) or a place query (Google).</div>`;
        }
        const radius = props.radius ?? 12;
        const aspect = props.aspectRatio ?? "16/9";
        const title = props.title || "Map";
        return `<div class="emk-map" style="position:relative;width:100%;aspect-ratio:${aspect};overflow:hidden;border-radius:${radius}px;border:1px solid rgba(0,0,0,0.08);background:#f1f5f9;font-family:inherit"><iframe src="${escapeAttr(url)}" title="${escapeAttr(title)}" loading="lazy" referrerpolicy="no-referrer-when-downgrade" style="position:absolute;inset:0;width:100%;height:100%;border:0" allowfullscreen></iframe><a href="${escapeAttr(url.startsWith("https://www.openstreetmap.org") ? `https://www.openstreetmap.org/?mlat=${props.query.split(",")[0]}&mlon=${props.query.split(",")[1]}` : url)}" target="_blank" rel="noopener noreferrer" style="position:absolute;bottom:8px;right:8px;background:rgba(255,255,255,0.9);padding:4px 8px;border-radius:4px;font-size:11px;color:#475569;text-decoration:none">${escapeHtml(title)} ↗</a></div>`;
    },
};
//# sourceMappingURL=map.js.map